// Import all language JSON files
import en from './en.json';
import es from './es.json';
import vi from './vi.json';
import ar from './ar.json';
import zh from './zh.json';
import prs from './prs.json';
import lo from './lo.json';
import ti from './ti.json';
import km from './km.json';
import mam from './mam.json';

// Export translations object for i18n
export const translations = {
  en,
  es,
  vi,
  ar,
  zh,
  prs,
  lo,
  ti,
  km,
  mam
};

export default translations;

